import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2.4a3.6 3.6 0 0 0-.6 7.15V17a.6.6 0 1 0 1.2 0V9.55A3.601 3.601 0 0 0 12 2.4Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.316 13.963a.6.6 0 1 0-.231-1.177c-1.729.34-3.236.904-4.328 1.64-1.08.728-1.857 1.702-1.857 2.868 0 1.563 1.38 2.78 3.137 3.57 1.813.816 4.275 1.305 6.963 1.305 2.688 0 5.151-.49 6.964-1.305 1.757-.79 3.136-2.007 3.136-3.57 0-1.166-.777-2.14-1.856-2.867-1.092-.737-2.6-1.302-4.328-1.641a.6.6 0 1 0-.231 1.177c1.627.32 2.97.839 3.888 1.458.932.63 1.327 1.285 1.327 1.873 0 .797-.747 1.719-2.428 2.475-1.626.732-3.913 1.2-6.472 1.2-2.558 0-4.846-.468-6.47-1.2-1.683-.756-2.43-1.678-2.43-2.475 0-.588.395-1.244 1.328-1.873.919-.62 2.261-1.138 3.888-1.458Z"
    />
  </svg>
`;
